import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Accordion } from "react-bootstrap"
import AccordionItem from "./accordion-item"
import "./section-accordion-v2.scss"

const SectionAccordionV2 = ({ accordionItems, cta, heading }) => {
  const [activeIndex, setActiveIndex] = useState("")
  return (
    <section className="section-accordion-v2">
      <div className="container-v2">
        {heading && (
          <h2 className="section-accordion-v2--heading">
            <TextLockupV2>{heading}</TextLockupV2>
          </h2>
        )}
        {accordionItems && accordionItems?.length > 0 && (
          <div className="section-accordion-v2--accordion-items">
            <Accordion activeKey={activeIndex} onSelect={setActiveIndex}>
              {accordionItems.map(item => (
                <AccordionItem
                  activeIndex={activeIndex}
                  className="g-accordion-cards accordion"
                  content={item.content}
                  heading={item.accordionHeading}
                  index={item.id}
                  isAccordion={true}
                  key={item.id}
                />
              ))}
            </Accordion>
          </div>
        )}

        {cta && cta?.path && cta.text && (
          <div className="section-accordion-v2--cta">
            <p className="section-accordion-v2--cta-button">
              <ButtonV2
                accessibilityLabel={cta?.accessibilityLabel}
                className={getButtonClasses(cta?.buttonStyle, cta?.buttonSize)}
                href={cta?.path}
                key={cta?.id}
                showArrow={cta?.showArrow === "Yes" ? true : false}
                text={cta?.text}
              />
            </p>
          </div>
        )}
      </div>
    </section>
  )
}

export default SectionAccordionV2

SectionAccordionV2.propTypes = {
  accordionItems: PropTypes.array.isRequired,
  cta: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
}
